import { BrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from './components/ErrorBoundary';
import { SessionExpiredModal } from './components/SessionExpiredModal';
import { Toaster } from './components/ui/Toast';
import { TooltipProvider } from './components/ui/Tooltip';
import { AppRoutes } from './router';

const VERSION = 'V1';

export default function App() {
  return (
    <BrowserRouter>
      <TooltipProvider delayDuration={300}>
        <ErrorBoundary>
          <AppRoutes version={VERSION} />
        </ErrorBoundary>
        <SessionExpiredModal />
        <Toaster />
      </TooltipProvider>
    </BrowserRouter>
  );
}
